<template>
    <Row type="none">
        <RowColumn>
            <Row type="none text-form">
                <div>
                    <TextTag class="d-flex justify-content-center" style="font-size: 32px" :is-block=true
                             :is-bold="true">
                        "{{ getUserCompany.name }}"
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">
                    <TextTag v-if="getUser.person.telephone" :is-block=true :is-bold="true">
                        {{ getUser.person.telephone }}
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('date') }}: {{ dateTimeFormat(getSale.createdAt) }}
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">
                    <TextTag v-if="getUser.person" :is-block=true :is-bold="true">
                        {{ $t('sale.seller') }}: {{ getUserPerson.givenName }} {{ getUserPerson.familyName }}
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">

                    <!--                    <TextTag :is-block=true :is-bold="true">-->
                    <!--                        {{ $t('printView.directorCompany') }}: {{ getUser.person.givenName }} {{-->
                    <!--                            getUser.person.familyName-->
                    <!--                        }}-->
                    <!--                    </TextTag>-->
                    <!--                    <hr class="m-0 p-0">-->
                    <!--                    <TextTag :is-block=true :is-bold="true">-->
                    <!--                        {{ $t('person.telephone') }}: {{ getUser.person.telephone }}-->
                    <!--                    </TextTag>-->
                    <!--                    <hr class="m-0 p-0">-->
                </div>
            </Row>
        </RowColumn>


        <GoBackButton class="mt-3 mr-2 go-back-btn"/>

        <div>
            <TableTag
                :bordered="'border: 1px solid black !important;'"
                class="table table-bordered table-sm mb-0"
                :body-properties="[
                {name: 'id', bordered: true},
                {name: getProductName, bordered: true},
                {name: getProductAmountAndUnitOfMeasure, bordered: true},
                {name: showPrice, bordered: true},
                {name: showTotalRowPrice, bordered: true},
                ]"
                :headers="[
                    {name: 'id', bordered: true},
                    {name: 'product.title', bordered: true},
                    {name: 'amount', bordered: true},
                    {name: 'price', bordered: true},
                    {name: 'sale.sum', bordered: true}
                    ]"
                :data="getSale.saleProducts.concat(getSale.saleServices)"
            >
            </TableTag>
            <pre class="d-none">{{sales}}</pre>
            <div class="table-bordered border text-uppercase font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('printView.totalSum') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(getSale.currency.id, getSale.totalPrice) }}</h5>
                </div>
            </div>

            <div class="table-bordered border font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('payed') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(getSale.currency.id, getSale.payedAmount) }}</h5>
                </div>
            </div>

            <div v-if="Math.round(getSale.totalPrice - getSale.payedAmount) > 0 && !getSale.transaction"
                 class="table-bordered border font-weight-bold d-flex justify-content-around">
                <div>
                    <h5>{{ $t('debt') }}</h5>
                </div>
                <div>
                    <h5>{{ showCurrencyById(getSale.currency.id, getSale.totalPurchaseAmount - getSale.payedAmount) }}</h5>
                </div>
            </div>
        </div>
        <RowColumn>
            <Row type="none text-form">
                <div class="mr-1">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('customer.title') }}: {{ getCustomerName(getSale) }}
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">
                    <TextTag v-if="getCustomerPhoneNumber(getSale)" :is-block=true :is-bold="true">
                        {{ getCustomerPhoneNumber(getSale) }}
                    </TextTag>
                    <hr v-if="getCustomerPhoneNumber(getSale)" class="m-0 p-0 border-bottom">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('hasPayed') }}: {{ getSale.transaction ? $t('yes') : $t('no') }}
                    </TextTag>
                    <hr class="m-0 p-0 border-bottom">
                    <TextTag class="d-flex justify-content-center" style="font-size: 24px" :is-block=true
                             :is-bold="true">
                        {{ $t('sale.thankPurchase') }}!!!
                    </TextTag>
                </div>

            </Row>
        </RowColumn>

        <GoBackButton class="my-3 mr-2 go-back-btn" v-if="getSale.saleProducts.length >= 37"/>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import TableTag from "@/components/html/TableTag";
import Row from "@/components/html/Row";
import TextTag from "@/components/html/TextTag";
import GoBackButton from "@/components/GoBackButton";
import RowColumn from "@/components/RowColumn";
import PrintStyleMixin from "@/mixin/PrintStyleMixin";

export default {
    name: "ShowPrintVersion",
    mixins: [currencyFormatMixin, dateFormattingMixin, PrintStyleMixin],
    components: {
        GoBackButton,
        TextTag,
        TableTag,
        Row,
        RowColumn
    },
    computed: {
        ...mapGetters(['getSale', 'isAuthenticated', 'getUser', 'getCustomer', 'getUserCompany', 'getUserPerson']),
        sales() {
            return this.getSale.saleProducts.map((product) => {
                console.log(product, 'prd')
                product.amount = parseFloat(product.amount)
            })
        }
    },
    methods: {
        ...mapActions(['fetchSale', 'fetchUser', 'fetchRefreshToken', 'fetchCustomer']),

        getProductName(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                return saleProductOrService.product.name
            }

            return saleProductOrService.service.name + ' ' + '(' + this.$t('service.title') + ')'
        },
        getProductAmountAndUnitOfMeasure(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                if (saleProductOrService.amountWithMeasure) {
                    return saleProductOrService.amountWithMeasure
                }

                this.checkForAdditionalUnitOfMeasure(saleProductOrService)
            }

            return parseInt(saleProductOrService.amount)

        },
        checkForAdditionalUnitOfMeasure(saleProduct) {
            let amount = saleProduct.amount
            let response = ''

            if (saleProduct.product.additionalUnitOfMeasures.length > 0) {
                let measures = saleProduct.product.additionalUnitOfMeasures.sort((a, b) => b.howMany - a.howMany)

                measures.map((measure, index) => {
                    if (index > 0) {
                        response += ', '
                    }

                    response += Math.floor(amount / measure.howMany) + ' ' + measure.unitOfMeasure

                    amount %= measure.howMany
                })

                if (amount > 0) {
                    response += ', ' + amount + ' ' + this.showUnitOfMeasurement(saleProduct)
                }

                return saleProduct.amountWithMeasure = response
            }

            return saleProduct.amountWithMeasure = saleProduct.amount + ' ' + this.showUnitOfMeasurement(saleProduct)
        },
        showTotalRowPrice(saleProduct) {
            return this.showCurrencyById(this.getSale.currency.id, saleProduct.price)
        },
        showPrice(saleProductOrService) {
            if (saleProductOrService['@type'] === "SaleProduct") {
                let isBonus = false
                let isPercent = false
                let percent = 0

                this.getSale.discount.find(d => {
                    if (
                        d.discount.discountType === 'product' &&
                        d.discount.discountProducts.find(dp => dp.isBonus && dp.product.id === saleProductOrService.product.id && parseFloat(saleProductOrService.price) === 0.0) !== undefined
                    ) {
                        return isBonus = true
                    } else if (d.discount.discountType === 'percent') {
                        if (
                            !d.discount.isForAllProducts &&
                            d.discount.discountProducts.find(dp => !dp.isBonus && dp.product.id === saleProductOrService.product.id) !== undefined
                        ) {
                            percent = d.discount.discountPercent
                            return isPercent = true
                        }
                    }
                })

                if (isBonus) {
                    return this.$t('sale.discount.discountProduct')
                }

                if (isPercent) {
                    return this.showCurrencyByIdWithoutSymbol(
                            this.getSale.currency.id,
                            this.calculateReversePercentAmount(saleProductOrService.price, percent) / saleProductOrService.amount
                        ) + ' - ' + percent + '% = ' +
                        this.showCurrencyByIdWithoutSymbol(
                            this.getSale.currency.id,
                            saleProductOrService.price / saleProductOrService.amount
                        )
                }

                return this.showCurrencyByIdWithoutSymbol(
                    this.getSale.currency.id,
                    saleProductOrService.price / saleProductOrService.amount
                )
            }

            return this.showCurrencyByIdWithoutSymbol(this.getSale.currency.id, saleProductOrService.price / saleProductOrService.amount)

        },
        showUnitOfMeasurement(saleProduct) {
            return this.showUnitOfMeasure(saleProduct.product.unitOfMeasure)
        },
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name : item.customer.person ?
                    item.customer.person.givenName + ' ' + item.customer.person.familyName : ''
        },
        getCustomerPhoneNumber(item) {
            if (!item.customer.isCompany) {
                return item.customer.person.telephone
            }

            return false
        },
        printWindow() {
            window.print()
            setTimeout(() => {
                this.$i18nHelper.toUrl('sales/sale')
            }, 1000)
        },
    },
    mounted() {
        this.$root.showOverlay = true
        this.fetchCustomer()
        this.fetchSale(this.$route.params.id)
            .then(() => {

            })
            .finally(() => {
                this.$root.showOverlay = false
                setTimeout(() => {
                    this.printWindow()
                }, 500)
            })
        this.appendPrintStyle({size: "A4", margin: "0 0", padding: "0"});
    },
    beforeDestroy() {
        this.removePrintStyle();
    }
}
</script>

<style scoped>
.table {
    margin-bottom: 0;
}

@media print {
    @page {
        size: A4;
    }

    .go-back-btn {
        display: none;
    }
}

.border-bottom {
    border-bottom: 1px solid black !important;
}

.text-form {
    font-family: 'Roboto', SansSerif, sans-serif;
    color: black !important;
}

.border {
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
    border-left: 1px solid black !important;
}
</style>
